// extracted by mini-css-extract-plugin
module.exports = {"container":"EnvironmentDetails__container___d6q0F","label":"EnvironmentDetails__label___1XRNj type__smallCaps___nMb1E","description":"EnvironmentDetails__description___xjbyO"};